var map = {
	"./excel-file.png": "5c91",
	"./image-file.png": "5a30",
	"./pdf-file.png": "1888",
	"./powerpoint-file.png": "7551",
	"./text-file.png": "40bf",
	"./word-file.png": "f8cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90b7";